module.exports = __webpack_public_path__ + "static/media/image-check.27d9c8cb.svg";